var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-btn"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.go(0)}}},[_vm._v("刷新")]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.$router.replace('/home')}}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }